import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import {
  Container,
  Box,
  Typography,
  Tabs,
  Tab,
  Hidden,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Button,
} from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import styles from "./WhyTeachOnTakbir.module.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

// --------------------------------------- Default component Start -------------------------------

const WhyTeachOnTakbir = (props) => {
  const { redirectToForm,getStartedHandler } = props;

  const [value, setValue] = React.useState(0);
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangem = (event) => {
    setValue(event.target.value);
  };

  const renderSelectedContent = () => {
    if (value >= 0 && value < props.QuestionAnsArr.length) {
      const ans = props.QuestionAnsArr[value];
      return (
        <div className={styles.PhoneItemContainer}>
          {ans.img ? <img src={ans.img} /> : ""}
          <div className={styles.PhoneItemBody}>
            <span>{ans.title}</span>
            <StyledButton variant="contained"  onClick={(e) => getStartedHandler()}>
              Get Started
            </StyledButton>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Container disableGutters sx={{ mt: 20 }}>
      <Box sx={{ width: "100% !important", mb: 10 }}>
        <Typography
          variant="p"
          sx={{
            display: "block",
            width: "100%",
            color: "#00277F",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Why teach on Takbir?
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontSize: "48px",
            textAlign: "center",
            fontWeight: "600",
            [theme.breakpoints.down("sm")]: {
              // width: "80%",
              fontSize: "22px",
            },
          }}
        >
          Take your subject of passion to global learners with our all-in-one,
          secured and easy-to-use teaching platform.
        </Typography>
      </Box>
      {/*  for desktop view */}
      <Hidden mdDown>
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            //   height: 224,
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{
              width: "50%",
              borderRight: 1,
              borderColor: "divider",
              "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
                width: "0",
              },
            }}
          >
            {props.QuestionArr.map((question, i) => {
              return (
                <StyledTab
                  key={i}
                  label={
                    <div>
                      {question} <ArrowForwardRoundedIcon />
                    </div>
                  }
                  {...a11yProps(i)}
                  sx={{ width: "600px" }}
                />
              );
            })}
          </Tabs>
          {props.QuestionAnsArr.map((ans, i) => {
            return (
              <StyledTabPanel value={value} index={i}>
                {ans.img ? (
                  <Box
                    sx={{
                      margin: "20px 0",
                      borderRadius: "12px !important",
                      overflow: "hidden !important",
                      "& img": {
                        height: "100% !important",
                        width: "100% !important",
                        objectFit: "contain !important",
                      },
                    }}
                    className={styles.cardImg}
                  >
                    <img src={ans.img} />
                  </Box>
                ) : (
                  ""
                )}

                <span style={{ width: "60%", textAlign: "center" }}>
                  {ans.title}
                </span>
                <StyledButton variant="contained" onClick={(e) => getStartedHandler()}>
                  Get Started
                </StyledButton>
              </StyledTabPanel>
            );
          })}
        </Box>
      </Hidden>
      {/*  fot mobile view */}
      <Hidden mdUp>
        <Box sx={{ margin: "0 auto", width: "90%", typography: "body1" }}>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={value}
              onChange={handleChangem}
            >
              {props.QuestionArr.map((question, i) => {
                return <MenuItem value={i}>{question}</MenuItem>;
              })}
            </Select>
          </FormControl>

          {renderSelectedContent()}
        </Box>
      </Hidden>
    </Container>
  );
};

export default WhyTeachOnTakbir;

const StyledTab = styled(Tab)(({ theme }) => ({
  padding: "24px 28px !important",
  minWidth: "405px !important",
  borderRadius: "1000px !important",
  "&.MuiButtonBase-root div": {
    width: "100% !important",
    fontSize: "16px !important",
    textTransform: "initial !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: " space-between !important",
  },
  "&.MuiButtonBase-root.Mui-selected": {
    color: "#fff !important",
    background: "#004FE0 !important",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "16px !important",
  },
}));

const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
  width: "80% !important",
  "& .MuiBox-root": {
    width: "100% !important",
    height: "100% !important",
    display: "flex !important",
    flexDirection: "column !important",
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  [theme.breakpoints.down("sm")]: {},
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "10px !important",
  padding: "14px 46px !important",
  background: "#004FE0 !important",
  boxShadow: "none !important",
  color: "#fff !important",
  borderRadius: "10px !important",
  "&:hover": {
    background: "#004FE0 !important",
    boxShadow: "none !important",
  },
  [theme.breakpoints.down("sm")]: {},
}));
